
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.19 94.19"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#cad3e0","cx":"47.1","cy":"47.1","r":"47.1"}}),_c('g',{attrs:{"fill":"none","stroke":"#FFF","stroke-width":"4","stroke-miterlimit":"10"}},[_c('path',{attrs:{"stroke-linecap":"round","d":"M56.67 58.85l11.12 11.12"}}),_c('circle',{attrs:{"cx":"62.23","cy":"64.41","r":"14.71"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M56.67 69.97l11.12-11.12"}})]),_c('g',{attrs:{"fill":"none","stroke":"#FFF","stroke-width":"4","stroke-miterlimit":"10"}},[_c('circle',{attrs:{"cx":"29.31","cy":"32.39","r":"14.71"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M22.99 33.07l4.64 4.07 8-9.5"}})]),_c('path',{attrs:{"fill":"none","stroke":"#FFF","stroke-width":"4","stroke-linecap":"round","stroke-miterlimit":"10","d":"M23.99 79.12L69.5 14.51"}})])
          )
        }
      }
    